import { State } from 'app/redux';

export const getLedgersAll = (state: State) => state.ledger.ledgers;

export const getLedgers = (state: State) => getLedgersAll(state).items;

export const getSearches = (state: State) => state.ledger.searches;
